import { buildCheckRequestAddress } from "../../Utils/helpers";

const DEFAULT_ADDRESS = {
  firstName: "",
  lastName: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zipCode: "",
};

export function addressFromUser(user) {
  if (!user) return { ...DEFAULT_ADDRESS };

  return {
    firstName: user.firstName?.trim() || "",
    lastName: user.lastName?.trim() || "",
    address1: user.address1?.trim() || "",
    address2: user.address2?.trim() || "",
    city: user.city?.trim() || "",
    state: user.state?.trim() || "",
    zipCode: user.zipCode?.trim() || "",
  };
}

export function formatMailingDisplay(address) {
  const name = [address.firstName, address.lastName].filter(Boolean).join(" ");
  const street = [address.address1, address.address2].filter(Boolean).join(", ");
  const cityLine = [address.city, address.state, address.zipCode].filter(Boolean).join(", ");

  return { name, street, cityLine };
}

export function trimAddressFields(address) {
  return {
    firstName: address.firstName.trim(),
    lastName: address.lastName.trim(),
    address1: address.address1.trim(),
    address2: address.address2.trim(),
    city: address.city.trim(),
    state: address.state.trim(),
    zipCode: address.zipCode.trim(),
  };
}

export function addressFromCheckStatus(address, user) {
  if (!address) return addressFromUser(user);

  const firstName =
    address.first_name?.trim() ||
    address.firstName?.trim() ||
    user?.firstName?.trim() ||
    "";
  const lastName =
    address.last_name?.trim() ||
    address.lastName?.trim() ||
    user?.lastName?.trim() ||
    "";

  const line1 =
    address.street?.trim() ||
    address.address_line1?.trim() ||
    address.line1?.trim() ||
    "";
  const line2 = address.address_line2?.trim() || address.line2?.trim() || "";

  let address1 = line1;
  let address2 = line2;

  if (!address2 && line1.includes(",")) {
    const [first, ...rest] = line1.split(",");
    address1 = first.trim();
    address2 = rest.join(",").trim();
  }

  return {
    firstName,
    lastName,
    address1,
    address2,
    city: address.city?.trim() || "",
    state: address.state?.trim() || "",
    zipCode:
      address.postal_code?.trim() ||
      address.zip?.trim() ||
      address.zipCode?.trim() ||
      "",
  };
}

export function formatCheckStatusAddress(address) {
  if (!address) return { name: "", street: "", cityLine: "" };

  const name =
    [address.first_name, address.last_name].map((part) => part?.trim()).filter(Boolean).join(" ") ||
    [address.firstName, address.lastName].map((part) => part?.trim()).filter(Boolean).join(" ") ||
    address.name?.trim() ||
    "";

  const streetLine1 =
    address.street?.trim() ||
    address.address_line1?.trim() ||
    address.line1?.trim() ||
    "";
  const streetLine2 = address.address_line2?.trim() || address.line2?.trim() || "";
  const street = [streetLine1, streetLine2].filter(Boolean).join(", ");

  const postalCode =
    address.postal_code?.trim() ||
    address.zip?.trim() ||
    address.zipCode?.trim() ||
    "";

  const cityLine = [address.city, address.state, postalCode, address.country]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(", ");

  return { name, street, cityLine };
}

export function isAddressComplete(address) {
  return Boolean(
    address.firstName &&
      address.lastName &&
      address.address1 &&
      address.city &&
      address.state &&
      address.zipCode
  );
}

export function buildUpdateAddressPayload(addressFields, { withdrawalId } = {}) {
  return {
    address: buildCheckRequestAddress(addressFields),
    ...(withdrawalId != null && withdrawalId !== "" ? { id: withdrawalId } : {}),
  };
}
